import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Input,
  SelectInput,
} from "../../../../../_metronic/_partials/controls";
import API from "../../../../helpers/devApi";
import * as Yup from "yup";
import * as Action from "../../../applicant/_redux/applicantActions";
import * as EmployeeListAction from "../../../employee/_redux/employeeActions";
import { swalConfirm, swalError, swalSuccess } from "../../../../helpers/swal";
import { Checkbox } from "antd";

const classList = [
  {
    value: "1st",
    label: "1st",
  },
  {
    value: "2nd",
    label: "2nd",
  },
  {
    value: "3rd",
    label: "3rd",
  },
];

const _init = {
  cgpa: "",
  cgpa_scale: "",
  education_level_id: "",
  degree_name: "",
  major_subject: "",
  result_type_id: "",
  result: "",
  passing_year: "",
  board_id: "",
  institute_name: "",
  applicant_id: "",
  is_foreign_degree: 0,
  mark: "",
  achievement: "",
  start_date: "",
  end_date: "",
  other_education_level: "",
  other_degree_name: "",
  is_ongoing: false,
};

const Education = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [educationData, setEducationData] = useState();
  const { id } = useParams();
  const [years, setYears] = useState([]);
  const {
    educationList,
    educationLavel,
    degree,
    board,
    // institute,
    resultType,
    // majorSubject,
    employeeProfile,
  } = useSelector(
    ({ applicant, employeeList }) => ({
      employeeProfile: employeeList.employeeProfile,
      educationLavel: applicant.educationLavel,
      degree: applicant.degree,
      board: applicant.board,
      // institute: applicant.institute,
      resultType: applicant.resultType,
      // majorSubject: applicant.majorSubject,
      educationList: applicant.educationList,
    }),
    shallowEqual
  );

  const getYears = (last) => {
    const currentYear = new Date().getFullYear();
    const last30Years = [];

    for (let i = 0; i < last; i++) {
      last30Years.push({ value: currentYear - i, label: currentYear - i + "" });
    }
    setYears(last30Years);
  };

  const validationSchema = Yup.object().shape({
    list: Yup.array().of(
      Yup.object().shape({
        education_level_id: Yup.string().required(
          "education level is required"
        ),
        other_education_level: Yup.string().when("education_level_id", {
          is: (val) =>
            educationLavel?.find((item) => item?.value == val)?.label ==
            "Others",
          then: Yup.string().required("Other Education Level is required"),
          otherwise: Yup.string(),
        }),
        institute_name: Yup.string().required("Institute is required"),
        passing_year: Yup.number().when("is_ongoing", {
          is: (val) => val == false,
          then: Yup.number().required("Passing year is required"),
          otherwise: Yup.number().nullable(),
        }),
        result_type_id: Yup.number().when("is_ongoing", {
          is: (val) => val == false,
          then: Yup.number().required("Result type is required"),
          otherwise: Yup.number().nullable(),
        }),
        major_subject: Yup.string().required("Major subject is required"),
        degree_name: Yup.string().required("Degree is required"),
        other_degree_name: Yup.string().when("degree_name", {
          is: (val) =>
            degree?.find((item) => item?.label == val)?.label == "Others",
          then: Yup.string().required("Other Degree is required"),
          otherwise: Yup.string(),
        }),
        result: Yup.string()
          .nullable()
          .when("result_type_id", {
            is: (val) =>
              resultType?.find((item) => item?.value == val)?.label ==
                "Class" ||
              resultType?.find((item) => item?.value == val)?.label ==
                "Division",
            then: Yup.string().required("result is required"),
            otherwise: Yup.string(),
          }),
        cgpa: Yup.number()
          .nullable()
          .when("result_type_id", {
            is: (val) =>
              resultType?.find((item) => item?.value == val)?.label == "Grade",
            then: Yup.number()
              .required("CGPA is required")
              .max(
                Yup.ref("cgpa_scale"),
                "CGPA must be less than or equal to GPA/ CGPA Scale"
              ),
            otherwise: Yup.number(),
          }),
        cgpa_scale: Yup.number()
          .nullable()
          .when("result_type_id", {
            is: (val) =>
              resultType?.find((item) => item?.value == val)?.label == "Grade",
            then: Yup.number().required("GPA/ CGPA Scale is required"),
            otherwise: Yup.number(),
          }),
      })
    ),
  });

  useEffect(() => {
    dispatch(Action.getAllEducationLavel());
    dispatch(Action.getAllBoard());
    dispatch(Action.getAllDegree());
    // dispatch(Action.getAllInstitute());
    dispatch(Action.getAllResultType());
    // dispatch(Action.getAllMajorSubject());
    getYears(111);
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(Action.getAllEducationByApplicants(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (educationList && educationList.length > 0) {
      const data = educationList?.map((item) => {
        return {
          id: item?.hrms_education__id,
          cgpa: item?.hrms_education__cgpa,
          cgpa_scale: item?.hrms_education__cgpa_scale,
          education_level_id: item?.hrms_education__education_level_id,
          degree_name: item?.hrms_education__degree_name,
          major_subject: item?.hrms_education__major_subject,
          result_type_id: item?.hrms_education__result_type_id,
          result: item?.hrms_education__result,
          passing_year: item?.hrms_education__passing_year,
          board_id: item?.hrms_education__board_id,
          institute_name: item?.hrms_education__institute_name,
          is_foreign_degree: item?.hrms_education__is_foreign_degree,
          mark: item?.hrms_education__mark,
          achievement: item?.hrms_education__achievement,
          start_date: item?.hrms_education__start_date,
          end_date: item?.hrms_education__end_date,
          other_education_level:
            item?.hrms_education__other_education_level ?? "",
          other_degree_name: item?.hrms_education__other_degree_name ?? "",
          is_ongoing: item?.hrms_education__is_ongoing,
        };
      });

      setEducationData({ list: data });
    } else {
      setEducationData({ list: [_init] });
    }
  }, [educationList]);

  const handleSaveProfile = async (values) => {
    const formData = values?.list?.map((item) => {
      return {
        cgpa: item?.cgpa == "" ? null : item?.cgpa,
        cgpa_scale: item?.cgpa_scale == "" ? null : item?.cgpa_scale,
        education_level_id: item?.education_level_id,
        degree_name: item?.degree_name,
        major_subject: item?.major_subject == "" ? null : item?.major_subject,
        result_type_id:
          item?.result_type_id == "" ? null : item?.result_type_id,
        result: item?.result == "" ? null : item?.result,
        passing_year: item?.passing_year == "" ? null : item?.passing_year,
        board_id: item?.board_id == "" ? null : item?.board_id,
        institute_name: item?.institute_name,
        applicant_id: Number(id),
        is_foreign_degree: item?.is_foreign_degree,
        mark: item?.mark == "" ? null : item?.mark,
        achievement: item?.achievement,
        start_date: item?.start_date == "" ? null : item?.start_date,
        other_education_level:
          item?.other_education_level == ""
            ? null
            : item?.other_education_level,
        other_degree_name:
          item?.other_degree_name == "" ? null : item?.other_degree_name,
        is_ongoing: item?.is_ongoing,
        end_date: item?.end_date == "" ? null : item?.end_date,
      };
    });

    if (id && formData?.length > 0) {
      await API.post(`/hrms_education/store`, formData)
        .then(async (res) => {
          if (res.data.success) {
            if (formData.length) {
              dispatch(
                Action.createProfileScore(
                  {
                    name: ["Education"],
                    applicant_id: id,
                  },
                  async () => {
                    dispatch(Action.getApplicantPersonalInfo(id));
                    await dispatch(Action.getAllEducationByApplicants(id));
                  }
                )
              );
            } else {
              dispatch(
                Action.updateProfileScore(
                  {
                    name: ["Education"],
                    applicant_id: id,
                  },
                  async () => {
                    dispatch(Action.getApplicantPersonalInfo(id));
                    await dispatch(Action.getAllEducationByApplicants(id));
                  }
                )
              );
            }
            swalSuccess("Education Information Updated Successfully!!");
            setLoading(false);
          } else {
            swalError("something went wrong");
          }
        })
        .catch((error) => {
          console.error(error);
        });
      setLoading(false);
    }
  };

  const handleDelete = async (itemId, index) => {
    swalConfirm().then(async (res) => {
      if (res.isConfirmed) {
        const list = educationData?.list;
        list.splice(index, 1);
        setEducationData({ list: list });

        // if (itemId) {
        //     await API.delete(
        //         `/sys_users/hrms_language_proficiency/delete/inCareerPortal/${itemId}`
        //     );
        //     dispatch(Action.getLanguageListForApplicant(id));
        // }
      }
    });
  };
  const handleAdd = async (values) => {
    // const list = educationData?.list;
    // let data = [...list, _init];
    const newArray = [...values.list];
    let data = [...newArray, _init];
    setEducationData({ list: data });
  };

  const handleCheckForeignDegree = (val, i, setFieldValue) => {
    if (val) {
      setFieldValue(`list[${i}].is_foreign_degree`, 1);
    } else {
      setFieldValue(`list[${i}].is_foreign_degree`, 0);
    }
  };

  return (
    <div className="card card_body_box mb-5">
      <Formik
        initialValues={educationData}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSaveProfile(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="card_header_with_edit_btn">
                  <div className="title">
                    <h2>Educational Information</h2>
                  </div>
                </div>
                <hr />
              </div>
            </div>
            {values?.list?.map((item, i, row) => (
              <div className="row" key={i}>
                <div className="col-md-12 mb-4">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <SelectInput
                            name={`list[${i}].education_level_id`}
                            label={"Education Level"}
                            options={educationLavel}
                            isRequired
                            onChange={(value) => {
                              setFieldValue(
                                `list[${i}].education_level_id`,
                                value
                              );
                            }}
                            value={item.education_level_id}
                          />
                          <div className="text-danger">
                            <ErrorMessage
                              name={`list[${i}].education_level_id`}
                            />
                          </div>
                        </div>

                        {educationLavel?.find(
                          (edu) => edu?.value == item?.education_level_id
                        )?.label == "Others" && (
                          <div className="col-md-6 mb-3">
                            <Input
                              label={"Other Education Level"}
                              isRequired
                              name={`list[${i}].other_education_level`}
                              onChange={(e) => {
                                setFieldValue(
                                  `list[${i}].other_education_level`,
                                  e.target.value
                                );
                              }}
                              value={item.other_education_level}
                            />
                            <div className="text-danger">
                              <ErrorMessage
                                name={`list[${i}].other_education_level`}
                              />
                            </div>
                          </div>
                        )}

                        <div className="col-md-6 mb-3">
                          <SelectInput
                            label={"Degree"}
                            options={degree}
                            isRequired
                            name={`list[${i}].degree_name`}
                            onChange={(value, item) => {
                              setFieldValue(
                                `list[${i}].degree_name`,
                                item?.label
                              );
                            }}
                            value={item.degree_name}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].degree_name`} />
                          </div>
                        </div>

                        {degree?.find((edu) => edu?.label == item?.degree_name)
                          ?.label == "Others" && (
                          <div className="col-md-6 mb-3">
                            <Input
                              label={"Other Degree"}
                              isRequired
                              name={`list[${i}].other_degree_name`}
                              onChange={(e) => {
                                setFieldValue(
                                  `list[${i}].other_degree_name`,
                                  e.target.value
                                );
                              }}
                              value={item.other_degree_name}
                            />
                            <div className="text-danger">
                              <ErrorMessage
                                name={`list[${i}].other_degree_name`}
                              />
                            </div>
                          </div>
                        )}

                        <div className="col-md-6 mb-3">
                          {/* <SelectInput
                            name={`list[${i}].major_subject`}
                            label={"Group/Major Subject/Concentration"}
                            isRequired
                            options={majorSubject}
                            onChange={(value, item) => {
                              setFieldValue(
                                `list[${i}].major_subject`,
                                item?.label
                              );
                            }}
                            value={item.major_subject}
                          /> */}
                          <Input
                            label={"Group/Major Subject/Concentration"}
                            isRequired
                            name={`list[${i}].major_subject`}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].major_subject`,
                                e.target.value
                              );
                            }}
                            value={item.major_subject}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].major_subject`} />
                          </div>
                        </div>

                        <div className="col-md-6 mb-3 mt-10">
                          <Checkbox
                            checked={item?.is_ongoing}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].is_ongoing`,
                                e.target.checked
                              );
                              setFieldValue(`list[${i}].result_type_id`, "");
                              setFieldValue(`list[${i}].result`, "");
                              setFieldValue(`list[${i}].cgpa`, "");
                              setFieldValue(`list[${i}].cgpa_scale`, "");
                              setFieldValue(`list[${i}].passing_year`, "");
                            }}
                          >
                            Appeared/Ongoing
                          </Checkbox>
                        </div>

                        {!item?.is_ongoing && (
                          <Fragment>
                            <div className="col-md-6 mb-3">
                              <SelectInput
                                label={"Grading System"}
                                name={`list[${i}].result_type_id`}
                                options={resultType}
                                isRequired
                                onChange={(value) => {
                                  setFieldValue(
                                    `list[${i}].result_type_id`,
                                    value
                                  );
                                }}
                                value={item.result_type_id}
                              />
                              <div className="text-danger">
                                <ErrorMessage
                                  name={`list[${i}].result_type_id`}
                                />
                              </div>
                            </div>

                            {(resultType?.find(
                              (row) => row.value == item.result_type_id
                            )?.label == "Division" ||
                              resultType?.find(
                                (row) => row.value == item.result_type_id
                              )?.label == "Class") && (
                              <div className="col-md-6 mb-3">
                                <SelectInput
                                  label={"Result"}
                                  name={`list[${i}].result`}
                                  options={classList}
                                  isRequired
                                  onChange={(value) => {
                                    setFieldValue(`list[${i}].result`, value);
                                  }}
                                  value={item.result}
                                />
                              </div>
                            )}

                            {resultType?.find(
                              (row) => row.value == item.result_type_id
                            )?.label == "Grade" && (
                              <Fragment>
                                <div className="col-md-6 mb-3">
                                  <Input
                                    label={"GPA/ CGPA"}
                                    isRequired
                                    name={`list[${i}].cgpa`}
                                    type="number"
                                    onChange={(e) => {
                                      setFieldValue(
                                        `list[${i}].cgpa`,
                                        e.target.value
                                      );
                                    }}
                                    value={item.cgpa}
                                  />
                                  <div className="text-danger">
                                    <ErrorMessage name={`list[${i}].cgpa`} />
                                  </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                  <Input
                                    label={"GPA/ CGPA Scale"}
                                    name={`list[${i}].cgpa_scale`}
                                    isRequired
                                    type="number"
                                    onChange={(e) => {
                                      setFieldValue(
                                        `list[${i}].cgpa_scale`,
                                        e.target.value
                                      );
                                    }}
                                    value={item.cgpa_scale}
                                  />
                                  <div className="text-danger">
                                    <ErrorMessage
                                      name={`list[${i}].cgpa_scale`}
                                    />
                                  </div>
                                </div>
                              </Fragment>
                            )}

                            <div className="col-md-6 mb-3">
                              <SelectInput
                                label={"Passing Year"}
                                name={`list[${i}].passing_year`}
                                options={years}
                                isRequired
                                onChange={(value) => {
                                  setFieldValue(
                                    `list[${i}].passing_year`,
                                    value
                                  );
                                }}
                                value={item.passing_year}
                              />
                              <div className="text-danger">
                                <ErrorMessage
                                  name={`list[${i}].passing_year`}
                                />
                              </div>
                            </div>

                            <div className="col-md-6 mb-3">
                              <Input
                                label={"Marks (%)"}
                                name={`list[${i}].mark`}
                                onChange={(e) => {
                                  setFieldValue(
                                    `list[${i}].mark`,
                                    e.target.value
                                  );
                                }}
                                value={item.mark}
                              />
                              <div className="text-danger">
                                <ErrorMessage name={`list[${i}].mark`} />
                              </div>
                            </div>

                            <div className="col-md-6 mb-3">
                              <SelectInput
                                label={"Board"}
                                name={`list[${i}].board_id`}
                                options={board}
                                onChange={(value) => {
                                  setFieldValue(`list[${i}].board_id`, value);
                                }}
                                value={item.board_id}
                              />
                              <div className="text-danger">
                                <ErrorMessage name={`list[${i}].board_id`} />
                              </div>
                            </div>
                          </Fragment>
                        )}

                        <div className="col-md-6 mb-3">
                          {/* <SelectInput
                            name={`list[${i}].institute_name`}
                            label={"Institute Name"}
                            options={institute}
                            isRequired
                            onChange={(value, item) => {
                              setFieldValue(
                                `list[${i}].institute_name`,
                                item?.label
                              );
                            }}
                            value={item.institute_name}
                          /> */}
                          <Input
                            label={"Institute Name"}
                            isRequired
                            name={`list[${i}].institute_name`}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].institute_name`,
                                e.target.value
                              );
                            }}
                            value={item.institute_name}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].institute_name`} />
                          </div>

                          <div className="mt-3 mb-3">
                            <Field
                              type="checkbox"
                              name={`list[${i}].is_foreign_degree`}
                              checked={values.list[i].is_foreign_degree === 1}
                              id={`foreign_degree_${i}`}
                              onChange={(e) =>
                                handleCheckForeignDegree(
                                  e.target.checked,
                                  i,
                                  setFieldValue
                                )
                              }
                            />

                            <label
                              className="form-check-label ml-2"
                              htmlFor={`foreign_degree_${i}`}
                            >
                              <b>Foreign Institute</b>
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <label>Start Date</label>
                          <input
                            name={`list[${i}].start_date`}
                            type="date"
                            className="form-control"
                            value={item.start_date}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].start_date`,
                                e.target.value
                              );
                              setFieldValue(`list[${i}].end_date`, "");
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].start_date`} />
                          </div>
                        </div>

                        {!item.is_ongoing && (
                          <div className="col-md-6 mb-3">
                            <label>End Date</label>
                            <input
                              name={`list[${i}].end_date`}
                              type="date"
                              className="form-control"
                              value={item.end_date}
                              onChange={(e) => {
                                setFieldValue(
                                  `list[${i}].end_date`,
                                  e.target.value
                                );
                              }}
                              min={item.start_date}
                            />
                            <div className="text-danger">
                              <ErrorMessage name={`list[${i}].end_date`} />
                            </div>
                          </div>
                        )}

                        <div className="col-md-6 mb-3">
                          <Input
                            label={"Achievement"}
                            name={`list[${i}].achievement`}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].achievement`,
                                e.target.value
                              );
                            }}
                            value={item.achievement}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].achievement`} />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 mb-3 d-flex">
                          {i === values?.list?.length - 1 && (
                            <button
                              type="button"
                              className="btn  add-button btn-sm text-white mr-5 text-nowrap"
                              onClick={() => {
                                handleAdd(values);
                              }}
                            >
                              <i
                                className="fa fa-plus text-white"
                                aria-hidden="true"
                              ></i>
                              Add Education
                            </button>
                          )}
                          {row.length > 1 && (
                            <button
                              type="button"
                              className="btn btn-danger btn-sm  text-nowrap"
                              onClick={() => {
                                handleDelete(item.id, i);
                              }}
                            >
                              <i
                                className="fa fa-minus  text-white"
                                aria-hidden="true"
                              ></i>
                              Remove Education
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div className="edit_btn_group d-flex modal-footer m-0 p-0">
              {/* <button className='btn btn-default mr-4' >Cancel</button> */}
              <button
                type="submit"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={loading}
              >
                Save
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Education;
